import React from 'react';
import { ACTIVE_YEARS } from '../data/archive';
import { LocalizedLink as Link, useT } from '../i18n';

const ArchiveBanner = () => {
  const t = useT();
  return <div className="bg-tb-dark text-white text-sm text-center px-4 py-2">
    <span className="font-bold">{t('The Branch AS er ikke lenger i drift.', 'The Branch AS is no longer in operation.')}</span>
    <span className="hidden md:inline"> {t(
      `Nettsiden står som et arkiv over arbeidet vårt fra ${ACTIVE_YEARS}.`,
      `This website remains as an archive of our work from ${ACTIVE_YEARS}.`
    )}</span>
    {' '}
    <Link to="/contact" className="underline text-tb-yellow whitespace-nowrap">
      {t('Vi er fortsatt å nå', 'You can still reach us')}
    </Link>
  </div>
}

export default ArchiveBanner;
